import React from "react";

/**
 * Shown once, before the first conversation. Conversation mode takes over
 * the composer and answers out loud, which is worth one sentence of warning.
 */
const VoiceModeIntro = ({ onStart, onCancel }) => (
  <div className="copilotConvoIntro" role="dialog" aria-label="Conversation mode">
    <h3 className="copilotConvoIntro__title">Conversation mode</h3>
    <p className="copilotConvoIntro__body">
      The microphone stays open and the copilot answers out loud. Talk over it to interrupt, or say
      &ldquo;stop&rdquo; when you are done.
    </p>
    <div className="copilotConvoIntro__actions">
      <button type="button" className="copilotConvoIntro__ghost" onClick={onCancel}>
        Not now
      </button>
      <button type="button" className="copilotConvoIntro__go" onClick={onStart}>
        Start talking
      </button>
    </div>
  </div>
);

export default VoiceModeIntro;
